import { useState } from 'react';
import { STAV_CONFIG } from '../../pages/FinanceDokladyInbox';

const fmtDateTime = (s) => (s ? new Date(s).toLocaleString('cs-CZ') : '—');

/**
 * Historie stavů dokladu.
 *
 * Patří do třetího sloupce, ne do záložky: norma tam chce to, co k položce jen
 * **informuje**, a historie je přesně to — nic se v ní needituje a nikdo se
 * kvůli ní nepřepíná. Jako záložka navíc zabírala místo v rejstříku vedle
 * hlavičky a položek, což jsou dvě věci, mezi kterými se člověk pohybuje
 * pořád. Na užší obrazovce, kde třetí sloupec není, zůstává jako záložka.
 *
 * Kreslí se jako osa: každý přechod má tečku v barvě svého stavu, takže cestu
 * dokladu jde přečíst bez čtení textu.
 */
export default function DokladHistoriePanel({ log = [], cardStyle, isDark = false, mutedColor, kompaktni = false }) {
    const [vse, setVse] = useState(false);
    if (log.length === 0) return null;

    const hranice = isDark ? 'rgba(255,255,255,0.08)' : 'var(--border-default)';
    const videt = vse ? log : log.slice(0, 4);

    return (
        <div className={kompaktni ? 'flex flex-col' : 'rounded-xl overflow-hidden flex flex-col'}
            style={kompaktni ? null : cardStyle}>
            <div className="flex items-center justify-between" style={{ padding: '9px 12px', borderBottom: `1px solid ${hranice}` }}>
                <span className="text-[10.5px] font-bold uppercase tracking-wide" style={{ color: mutedColor }}>Historie stavu</span>
                <span className="text-[10.5px]" style={{ color: mutedColor }}>
                    {log.length} {log.length === 1 ? 'přechod' : log.length < 5 ? 'přechody' : 'přechodů'}
                </span>
            </div>

            <div style={{ padding: '8px 12px 10px' }}>
                {videt.map((zapis, i) => {
                    const cfg = STAV_CONFIG[zapis.stav_na] || { label: zapis.stav_na, color: 'var(--text-tertiary)' };
                    const posledni = i === videt.length - 1;
                    return (
                        <div key={zapis.id} className="flex gap-2.5">
                            {/* Tečka + svislice = osa. Poslední zápis svislici nemá,
                                jinak by čára visela do prázdna. */}
                            <div className="flex flex-col items-center flex-shrink-0" style={{ width: 9, paddingTop: 5 }}>
                                <span style={{ width: 9, height: 9, borderRadius: 999, background: cfg.color, flexShrink: 0 }} />
                                {!posledni && <span style={{ width: 1, flex: 1, minHeight: 14, background: hranice, marginTop: 2 }} />}
                            </div>
                            <div className="min-w-0" style={{ paddingBottom: posledni ? 0 : 8 }}>
                                <div className="text-[12px] font-semibold" style={{ color: cfg.color }}>{cfg.label}</div>
                                <div className="text-[10.5px]" style={{ color: mutedColor }}>
                                    {fmtDateTime(zapis.created_at)}
                                    {zapis.uzivatel && ` · ${zapis.uzivatel.jmeno} ${zapis.uzivatel.prijmeni}`.trimEnd()}
                                </div>
                                {zapis.poznamka && (
                                    <div className="text-[11px] mt-0.5" style={{ color: 'var(--text-secondary)' }}>{zapis.poznamka}</div>
                                )}
                            </div>
                        </div>
                    );
                })}

                {log.length > 4 && (
                    <button type="button" onClick={() => setVse(v => !v)}
                        className="text-[11px] font-semibold mt-1"
                        style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: 'var(--text-secondary)' }}>
                        {vse ? 'Sbalit' : `Zobrazit všechny (${log.length})`}
                    </button>
                )}
            </div>
        </div>
    );
}
